// The clothing shop's items per slot (its tabs since the 2026-10-27 redesign; paging lives in shopGrid.mjs). Pure, node --test.
// {slot: [item ids]} — the character's own items; the second wardrobe (nat_*) first, so new things show on page 1.
export function shopColumns(catalog, character, slotIds) {
  const out = {};
  for (const slot of slotIds) {
    const ids = Object.entries(catalog).filter(([, c]) => c.category === slot && (c.character ?? 'natalka') === character).map(([id]) => id);
    out[slot] = [...ids.filter((id) => id.startsWith('nat_')), ...ids.filter((id) => !id.startsWith('nat_'))];
  }
  return out;
}
